import React, { useEffect, useState } from 'react'
import { useTranslation } from '../../locale/useTranslation';
import ActionButton from '../../framework/forms/helpercomponents/buttons/ActionButton';
import { PlanningHelper } from '../Planning/helper/PlanningHelper';
import { ENTITYNAME, PUBLISH_REPORT, FILEURL, LOCALSTORAGE_KEY, MODULETYPES, PLATFORM_SIMULCAST_CHANNEL_CONFIG, REPORT_TYPE, SCHEDULETYPE, PUBLISH_TYPE, PUBLISH_REPORT_CONFIG, getPublishReportConfig, EPG_EXPORT_STATUS, TOAST_TYPES } from '../../framework/constant/constant';
import { utility } from '../../framework/utility/utilityProvider';
import * as API from '../../framework/API/api';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import MyMultiSelect from '../../components/MyMultiSelect';
import BossDialog from '../../components/BossDialog';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import MyStatusCell from '../../components/MyStatusCell';
import RoundButton from '../../framework/forms/helpercomponents/buttons/RoundButton';
import { RadioButton } from '@progress/kendo-react-inputs';
import ToastNotification from "../../components/ToastNotification";

const EPGForm = (props) => {

    const { isFromSchedule = false, item = {}, setFooterMessage, isPopup = false } = props;

    const lang = useTranslation();
    const defaultDates = utility.getFirstAndLastDateOfMonth();

    const [dataItem, setDataItem] = useState({
        FromDate: defaultDates.FirstDate,
        ToDate: defaultDates.LastDate,
        Channels: [],
        ReportType: {},
        dateWiseSheet: false,
        IsSimulcast: false,
        Platform: {},
        channelGroup: [],
    });
    const [exportReports, setExportReports] = useState([]);
    const [channels, setChannels] = useState([]);
    const [showProgressPopup, setShowProgressPopup] = useState({ show: false, resultData: [] });
    const [showIssuesPopup, setShowIssuesPopup] = useState({ show: false, channelIssues: [] });
    const [isChannelGroup, setIsChannelGroup] = useState(false);
    const [channelGroups, setChannelGroups] = useState([]);
    const [isExportButtonDisable, setIsExportButtonDisable] = useState(false);
    const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {
        let exportReportRes = await API.getData(ENTITYNAME.ExportTemplate, { sort: { Name: 1 }, query: [['ModuleType.SID', '=', MODULETYPES[6].SID],["Archive", "!=", true]] });
        setExportReports(exportReportRes.data);
        let channelRes = await API.getValidChannels();
        setChannels(channelRes.data);
        let exportValue = exportReportRes.data?.length > 0 ? exportReportRes.data.find(x => x.IsDefault) : {};
        let channelGroupRes = await API.getData(ENTITYNAME.ChannelGroups, { sort: { Name: 1 } });
        setChannelGroups(channelGroupRes.data);

        if (isFromSchedule) {
            setDataItem({ ...dataItem, FromDate: item.date ? utility.convertMilisecondsToDateString(item.date.getTime()) : defaultDates.FirstDate, ToDate: item.date ? utility.convertMilisecondsToDateString(item.date.getTime()) : defaultDates.LastDate, Channels: item.channel ? [item.channel] : [], ReportType: getPublishReportConfig(PUBLISH_REPORT.CSV), dateWiseSheet: false })
        } else {
            setDataItem({ ...dataItem, ExportReport: exportValue, ReportType: getPublishReportConfig(PUBLISH_REPORT.CSV) });
        }
    }

    const onChange = async (e) => {
        const { name, value } = e.target;
        if (name == "dateWiseSheet") {
            setDataItem({ ...dataItem, dateWiseSheet: !dataItem.dateWiseSheet });
        } if (name == "IsSimulcast") {
            setDataItem({ ...dataItem, IsSimulcast: !dataItem.IsSimulcast });
        } else {
            setDataItem({ ...dataItem, [name]: value });
        }
    };

    const isValid = () => {

        if (dataItem.ReportType.TemplateReq && (!dataItem.ExportReport || Object.keys(dataItem.ExportReport).length == 0)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_the_value_in_template_name_first_export_report_error_message });
            return false;
        }

        if (!dataItem.ReportType || Object.keys(dataItem.ReportType).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_the_value_in_format_first_export_report_error_message });
            return false;
        }

        if (dataItem.Channels == undefined || dataItem.Channels.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_channel_error_message });
            return false;
        }

        if (dataItem.FromDate == undefined || dataItem.FromDate.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_from_date });
            return false;
        }

        if (dataItem.ToDate == undefined || dataItem.ToDate.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_to_date_error_message });
            return false;
        }

        if (dataItem.FromDate > dataItem.ToDate) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.to_date_should_be_greater_than_from_date_error_message });
            return false;
        }

        if (dataItem.IsSimulcast && (!dataItem.Platform || Object.keys(dataItem.Platform).length == 0)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_platform_error_message });
            return false;
        }
        return true;

    }

    const handleEPGExport = async () => {

        if (!isValid()) return;
        setIsExportButtonDisable(true);
        // Add footer message
        setFooterMessage(lang.please_wait_export_report_message);

        const offSetHours = new Date(PlanningHelper.getDayStartTime(dataItem.Channels) ?? 0).getUTCHours();
        const mainTimeZone = PlanningHelper.getMainTimeZone(dataItem.Channels);

        //ALWAYS SUBTRACT OFFSET
        let offsetTime = (offSetHours * 3600000) - (mainTimeZone.IsNegativeOffset ? -mainTimeZone.Offset : mainTimeZone.Offset);
        console.log(offsetTime)

        let company = utility.getValue(LOCALSTORAGE_KEY.COMPANY)
         const isUbs = company?.Name.toLowerCase() == "ubs";
         if(isUbs){
             offsetTime = 0;
         }
        let fromDate = new Date(dataItem.FromDate).getTime() + offsetTime;
        const addOneDayInToDate = dataItem?.ReportType?.SID != PUBLISH_REPORT.STARHUB_OTT && dataItem?.ReportType?.SID != PUBLISH_REPORT.STARHUB_IPTV && dataItem?.ReportType?.SID != PUBLISH_REPORT.STARHUB_FUZE && dataItem?.ReportType?.SID != PUBLISH_REPORT.STARHUB_SINGTEL
        let toDate = new Date(dataItem.ToDate).getTime() + offsetTime + (addOneDayInToDate ? (24 * 3600000) - 1 : 0); // adding 1 day extra in to date to cover complete date

        let payload = dataItem.ReportType.TemplateReq
            ? {
                reportType: dataItem.ReportType.Description,
                param: {
                    sort: { SlotDateTime: 1 },
                    tableName: dataItem.ExportReport.ModuleType.SaveEntityName,
                    query: [['SlotDateTime', '>=', fromDate], ['SlotDateTime', '<=', toDate], ['Type', '=', SCHEDULETYPE.Header]],
                    customColumns: dataItem.ExportReport.Columns,
                    companyTimeZone: company?.TimeZone,
                    dateWiseSheet: dataItem.dateWiseSheet ?? false
                },
                Dates : {
                    FromDate: fromDate,
                    ToDate: toDate
                },
                TemplateName: dataItem.ExportReport.Name,
                channels: dataItem.Channels
            }
            : {
                param: {
                    query: {
                        fromDate: fromDate,
                        toDate: toDate,
                        channels: dataItem.Channels
                    },
                    isSimulcast: dataItem?.IsSimulcast ?? false,
                    platform: dataItem?.IsSimulcast ? dataItem?.Platform?.SID : null
                },
                reportType: dataItem.ReportType.Description,
            }

        const epgResponse = await API.getEPGReports(payload);
        console.log(epgResponse);

        if (epgResponse?.success && epgResponse?.data?.length > 0) {
            setFooterMessage(lang.epg_report_success_message);
            setShowProgressPopup({ show: true, resultData: epgResponse?.data });
        }
        else if (!epgResponse?.success && epgResponse?.data?.length > 0) {
            // Extract channel-wise issues for the issues popup
            const channelIssues = epgResponse.data
                .filter(ch => !ch.success && ch.data?.issues?.length > 0)
                .map(ch => ({
                    channelName: ch.channel?.FullChannelName || 'Unknown',
                    channelSID: ch.channel?.SID,
                    message: ch.message,
                    issues: ch.data.issues,
                    totalIssues: ch.data.total
                }));

            if (channelIssues.length > 0) {
                setShowIssuesPopup({ show: true, channelIssues });
                setFooterMessage(epgResponse.message || lang.report_is_not_exported_error_message);
            } else {
                // Has data but no parseable issues — show regular progress popup
                setShowProgressPopup({ show: true, resultData: epgResponse?.data });
                setFooterMessage(epgResponse.message || lang.report_is_not_exported_error_message);
            }
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.report_is_not_exported_error_message });
            setFooterMessage(lang.report_is_not_exported_error_message);
        }
        setIsExportButtonDisable(false);   // enable button again
    }

    const handleChannelGroups = (e) => {
        const groups = e.target.value ?? [];

        const channelsFromGroups = groups.flatMap(group =>
            group.LinkedChannels ?? []
        );
        const uniqueChannels = Array.from(
            new Map(channelsFromGroups.map(ch => [ch._id, ch])).values()
        );

        setDataItem(prev => ({
            ...prev,
            channelGroup: groups,
            Channels: uniqueChannels
        }));
    };

    const Mystatuscell = (props) => {
        const { dataItem } = props;

        let title = "";
        let tileBackColor = "";

        if (dataItem?.success == true && dataItem?.isPublished == undefined) {
            title = EPG_EXPORT_STATUS.EPG_GENERATED;
            tileBackColor = "#007BFF";
        } else if (dataItem?.success == false) {
            title = EPG_EXPORT_STATUS.FAILED;
            tileBackColor = "#E72929";
        } else if (dataItem?.isPublished == true) {
            title = EPG_EXPORT_STATUS.PUBLISH_SUCCESS;
            tileBackColor = "#63aa43";
        } else if (dataItem?.isPublished == false) {
            title = EPG_EXPORT_STATUS.PUBLISH_FAILED;
            tileBackColor = "#FE9328";
        }

        return (
            <MyStatusCell {...props} title={title} tileBackColor={tileBackColor} />
        );
    };

    const downloadSingleFile = (fileName) => {
        if (!fileName) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.filename_not_found_error_message });
            return;
        }
        window.open(FILEURL().BASEURL + 'downloadReport/' + fileName, "_blank");
    }

    const MyCommandCell = (props) => (
        <td style={{ display: "flex", alignItems: "center", justifyContent: "center" }} className="ml-1" >
            <RoundButton title={lang.download_label} icon="download" onClick={() => downloadSingleFile(props?.dataItem?.data)} />
        </td>
    )

    const handleDownloadAll = async (e) => {
        e.preventDefault();

        const files = showProgressPopup?.resultData?.filter(x => x?.data);
        if (!files?.length) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.unable_to_download_all_files_error_message });
            return;
        }

        for (const file of files) {
            const link = document.createElement("a");
            link.href = FILEURL().BASEURL + "downloadReport/" + file.data;
            link.setAttribute("download", file.data);
            link.style.display = "none";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            await new Promise(res => setTimeout(res, 800));
        }
    };


    return (
        <>
            <div style={{ display: "flex", justifyContent: "flex-start", marginLeft: "-10px", marginBottom: "10px" }}>
                <ActionButton
                    icon="download"
                    title={lang.export_button_tooltip}
                    name={lang.export_button_text}
                    onClick={handleEPGExport}
                    disabled={isExportButtonDisable}
                />
            </div>
            <div className="row mt-2">
                <div className={`col-${isPopup ? "6" : "3"} form-group`}>
                    <label>{lang.report_type_label} *</label>
                    {dataItem.ReportType?.Description == REPORT_TYPE.XLSX && <span className="float-right">
                        <input name="dateWiseSheet" type="checkbox" value={dataItem.dateWiseSheet} checked={dataItem.dateWiseSheet} onChange={onChange} />
                        <label className="ml-1">{lang.date_wise_sheet_label}</label>
                    </span>}
                    <DropDownList
                        data={PUBLISH_REPORT_CONFIG.filter(data => data.PUBLISH_TYPE == PUBLISH_TYPE.EPGs && (data.clients.includes(company?.Name?.toLowerCase()) || data.clients.includes('generic')))}
                        name="ReportType"
                        textField="Description"
                        dataItemKey="SID"
                        value={dataItem.ReportType}
                        onChange={onChange}
                    />
                </div>
                {dataItem.ReportType.TemplateReq && <div className={`col-${isPopup ? "6" : "3"} form-group`}>
                    <label>{lang.template_name_label}</label>
                    <DropDownList
                        data={exportReports}
                        name="ExportReport"
                        textField="Name"
                        dataItemKey="_id"
                        value={dataItem.ExportReport}
                        onChange={onChange}
                    />
                </div>}
                <div className={`col-${isPopup ? "6" : "3"} form-group`}>
                    <div style={{ display: "flex", gap: "15px", marginBottom: "2px" }}>
                        <label style={{ display: "inline-flex", alignItems: "center", gap: "6px", cursor: "pointer" }}>
                            <RadioButton
                                name="channelType"
                                checked={!isChannelGroup}
                                onChange={() => setIsChannelGroup(false)}
                            />
                            {lang.channels_label} *
                        </label>
                        <label style={{ display: "inline-flex", alignItems: "center", gap: "6px", cursor: "pointer" }}>
                            <RadioButton
                                name="channelType"
                                checked={isChannelGroup}
                                onChange={() => setIsChannelGroup(true)}
                            />
                            {lang.channel_groups_label} *
                        </label>

                    </div>
                    <MyMultiSelect
                        style={{ backgroundColor: "white", width: "100%" }}
                        data={isChannelGroup ? channelGroups : channels}
                        name={isChannelGroup ? "channelGroup" : "Channels"}
                        textField={isChannelGroup ? "Description" : "FullChannelName"}
                        dataItemKey="_id"
                        value={isChannelGroup ? dataItem.channelGroup : dataItem.Channels}
                        onChange={(e) => {
                            if (isChannelGroup) {
                                handleChannelGroups(e);
                            } else {
                                onChange(e);
                            }
                        }}
                    />
                </div>
                <div className={`col-${isPopup ? "6" : "3"} form-group`}>
                    <label>{lang.from_date_label} *</label>
                    <input
                        type="date"
                        className="form-control form-control-sm"
                        name="FromDate"
                        value={dataItem.FromDate || ''}
                        onChange={onChange}
                    />
                </div>
                <div className={`col-${isPopup ? "6" : "3"} form-group`}>
                    <label>{lang.to_date_label} *</label>
                    <input
                        type="date"
                        className="form-control form-control-sm"
                        name="ToDate"
                        value={dataItem.ToDate || ''}
                        onChange={onChange}
                    />
                </div>
                {/* if simulcast selected then show a dropdown of platform enum
                {dataItem.IsSimulcast && <div className={`col-${isPopup ? "6" : "3"} form-group`}>
                    <div className="form-group">
                        <label htmlFor="TabView">{lang.platform_label} *</label>
                        <DropDownList
                            data={Object.keys(PLATFORM_SIMULCAST_CHANNEL_CONFIG).map(platform => ({ SID: PLATFORM_SIMULCAST_CHANNEL_CONFIG[platform], Name: platform }))}
                            name="Platform"
                            textField="Name"
                            dataItemKey="SID"
                            value={dataItem.Platform}
                            onChange={onChange}
                        />
                    </div>
                </div>}
                {/* checkbox for SIMULCAST */}
                {/* <div className={`col-${isPopup ? "2" : "1"}`} style={{ display: "flex", alignItems: "center" }}>
                    <input name="IsSimulcast" type="checkbox" value={dataItem.IsSimulcast} checked={dataItem.IsSimulcast} onChange={onChange} />
                    <label className="ml-1">{lang.simulcast_label}</label>
                </div> */}
                {showProgressPopup.show && <BossDialog title={lang.epg_export_status} onClose={() => setShowProgressPopup({ show: false, resultData: [] })} width="900px" >
                    <div style={{ marginBottom: "8px" }}>
                        <ActionButton icon="download" btnColor="success" title="Download All" name="Download All" onClick={handleDownloadAll} />
                    </div>
                    <Grid resizable={true} data={showProgressPopup.resultData} style={{ height: "50vh", marginTop: '5px', display: 'flex' }}>
                        <GridColumn cell={MyCommandCell} width={"60px"} />
                        <GridColumn field="message" title="Message" width={400} />
                        <GridColumn field="channel.FullChannelName" title={lang.channel_column} width={"130px"} />
                        <GridColumn field="data" title={lang.filename_label} />
                        <GridColumn field="success" title={lang.status_column} cell={Mystatuscell} width={"160px"} />
                  
                    </Grid>
                </BossDialog>}

                {/* EPG Issues Popup — shown when export fails due to gaps/overlaps */}
                {showIssuesPopup.show && <BossDialog
                    title={"EPG Export Issues"}
                    onClose={() => setShowIssuesPopup({ show: false, channelIssues: [] })}
                    width="1100px"
                >
                    <div style={{ padding: "8px 0" }}>
                        <div style={{
                            display: "flex", alignItems: "center", gap: "10px",
                            padding: "10px 14px", marginBottom: "16px",
                            background: "linear-gradient(135deg, #fff5f5 0%, #ffe0e0 100%)",
                            border: "1px solid #f5c6cb", borderRadius: "8px"
                        }}>
                            <span style={{ fontSize: "22px" }}>⚠️</span>
                            <div>
                                <strong style={{ color: "#c0392b", fontSize: "14px" }}>Export Failed</strong>
                                <div style={{ fontSize: "12px", color: "#6c757d", marginTop: "2px" }}>
                                    The following channels have scheduling issues (gaps or overlaps) that must be resolved before exporting.
                                </div>
                            </div>
                        </div>

                        {showIssuesPopup.channelIssues.map((channel, chIdx) => (
                            <div key={chIdx} style={{
                                marginBottom: "18px", border: "1px solid #e0e0e0",
                                borderRadius: "8px", overflow: "hidden",
                                boxShadow: "0 1px 4px rgba(0,0,0,0.06)"
                            }}>
                                {/* Channel Header */}
                                <div style={{
                                    display: "flex", alignItems: "center", justifyContent: "space-between",
                                    padding: "10px 16px",
                                    background: "linear-gradient(135deg, #2c3e50 0%, #34495e 100%)",
                                    color: "#fff"
                                }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <span style={{ fontSize: "16px" }}>📺</span>
                                        <strong style={{ fontSize: "14px" }}>{channel.channelName}</strong>
                                        {channel.channelSID && <span style={{
                                            fontSize: "11px", background: "rgba(255,255,255,0.2)",
                                            padding: "2px 8px", borderRadius: "10px"
                                        }}>SID: {channel.channelSID}</span>}
                                    </div>
                                    <span style={{
                                        fontSize: "11px", background: "#e74c3c",
                                        padding: "3px 10px", borderRadius: "12px", fontWeight: "600"
                                    }}>
                                        {channel.totalIssues} {channel.totalIssues === 1 ? 'Issue' : 'Issues'}
                                    </span>
                                </div>

                                {/* Issues Table */}
                                <div style={{ overflowX: "auto" }}>
                                    <table style={{
                                        width: "100%", borderCollapse: "collapse",
                                        fontSize: "12.5px"
                                    }}>
                                        <thead>
                                            <tr style={{ background: "#f8f9fa" }}>
                                                <th style={issueTableHeaderStyle}>#</th>
                                                <th style={issueTableHeaderStyle}>Type</th>
                                                <th style={issueTableHeaderStyle}>Program 1</th>
                                                <th style={issueTableHeaderStyle}>Start Time</th>
                                                <th style={issueTableHeaderStyle}>End Time</th>
                                                <th style={issueTableHeaderStyle}>Program 2</th>
                                                <th style={issueTableHeaderStyle}>Start Time</th>
                                                <th style={issueTableHeaderStyle}>Duration</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {channel.issues.map((issue, issIdx) => (
                                                <tr key={issIdx} style={{
                                                    borderBottom: "1px solid #eee",
                                                    background: issIdx % 2 === 0 ? "#fff" : "#fafbfc"
                                                }}>
                                                    <td style={issueTableCellStyle}>{issIdx + 1}</td>
                                                    <td style={issueTableCellStyle}>
                                                        <span style={{
                                                            display: "inline-block",
                                                            padding: "3px 10px",
                                                            borderRadius: "12px",
                                                            fontSize: "11px",
                                                            fontWeight: "600",
                                                            textTransform: "capitalize",
                                                            background: issue.type === 'gap'
                                                                ? "#fff3cd" : "#f8d7da",
                                                            color: issue.type === 'gap'
                                                                ? "#856404" : "#721c24",
                                                            border: issue.type === 'gap'
                                                                ? "1px solid #ffc107" : "1px solid #f5c6cb"
                                                        }}>
                                                            {issue.type === 'gap' ? '⏸ Gap' : '⚡ Overlap'}
                                                        </span>
                                                    </td>
                                                    <td style={{ ...issueTableCellStyle, fontWeight: "500" }}>
                                                        {issue.titles?.[0] || '—'}
                                                    </td>
                                                    <td style={{ ...issueTableCellStyle, color: "#6c757d", fontFamily: "monospace", fontSize: "11.5px" }}>
                                                        {issue.startTimes_str || '—'}
                                                    </td>
                                                      <td style={{ ...issueTableCellStyle, color: "#6c757d", fontFamily: "monospace", fontSize: "11.5px" }}>
                                                        {issue.endTime_str || '—'}
                                                    </td>
                                                    <td style={{ ...issueTableCellStyle, fontWeight: "500" }}>
                                                        {issue.titles?.[1] || '—'}
                                                    </td>
                                                    <td style={{ ...issueTableCellStyle, color: "#6c757d", fontFamily: "monospace", fontSize: "11.5px" }}>
                                                        {issue.startTimes2_str || '—'}
                                                    </td>
                                                    <td style={issueTableCellStyle}>
                                                        <span style={{
                                                            fontWeight: "700",
                                                            color: issue.type === 'gap' ? "#e67e22" : "#c0392b"
                                                        }}>
                                                            {issue.gapDuration_str || issue.overlapBy_str || '—'}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ))}
                    </div>
                </BossDialog>}
            </div>
        </>
    )
}

// Shared styles for the issues table
const issueTableHeaderStyle = {
    padding: "8px 12px",
    textAlign: "left",
    fontWeight: "600",
    color: "#495057",
    borderBottom: "2px solid #dee2e6",
    whiteSpace: "nowrap"
};

const issueTableCellStyle = {
    padding: "9px 12px",
    textAlign: "left",
    verticalAlign: "middle"
};

export default EPGForm